import React, { useEffect, useRef, useState } from 'react';
import { useParams, useHistory } from 'react-router-dom';
import { Badge, Card, Row, Col, Button, Form, Table, Tab, Tabs } from 'react-bootstrap';
import { Page, Terminal } from 'components';
import Logs from '../Logs';
import Header from '../../../../components/Header/Header';
import dateformat from 'utils/dateformat';
import { getToken } from 'actions';
import Api from 'services/Api';
import ApiGServer from 'services/ApiGServer';
import Graphic from '../Graphic';
import '../../../Suporte/components/Conected/Conected.css';

const wsUrl = process.env.REACT_APP_API_MONITORA.replace('https', 'wss').replace('http', 'ws');
const refreshRate = 15000
let socket;

const Conected = (props) => {
  const history = useHistory();
  const requestRef = useRef(null);
  const imageRef = useRef(null);
  const prevImageUrlRef = useRef(null);
  const serialNumber = useParams().id;

  const user = JSON.parse(localStorage.getItem('userData'));
  if (user?.permission?.supportdry?.read !== true) {
    window.location.replace('/home')
  }

  const [imageSrc, setImageSrc] = useState('');
  const [errors, setErrors] = useState([]);
  const [connectionStabished, setConnectionStabished] = useState(false)
  const [inputValueAlert, setInputValueAlert] = useState('');
  const [response, setResponse] = useState('Console\n');
  const [equipConfig, setEquipConfig] = useState({
    'serial': '--',
    'webcam': false,
    'freq_v': '--',
    'serv_e': '--',
    'serv_m': '--',
    'serv_d': '--',
    'calib_id': '--',
    'calib': '--',
    'eixo_x': '--',
    'eixo_y': '--',
    'eixo_z': '--',
    'v_firmware': '--',
    'v_firmware_osc': '--',
    'activation_date': '--',
    'activation_days': '--',
    'volume_corr_densidade': '--',
    'densidade_esfera': '--',
    'offset_bal1': '--',
    'offset_bal2': '--',
    'cross_check': '--',
    'sw': '--',
    'sws': '--'
  })

  const [isDark, setIsDark] = useState(document.body.classList.contains('dark-theme'));
  const [ajuste, setAjuste] = useState('');
  const [savingAjuste, setSavingAjuste] = useState(false);
  const panelClass = isDark ? 'conected-panel bg-dark text-light border-secondary' : 'conected-panel bg-light text-dark';
  const panelHeaderClass = isDark ? 'bg-dark text-light border-secondary' : 'bg-light text-dark';
  const canWrite = user?.permission?.supportdry?.write === true && connectionStabished;
  const canUpdateAjuste = user?.permission?.supportdry?.write === true;

  useEffect(() => {
    const observer = new MutationObserver(() => {
      setIsDark(document.body.classList.contains('dark-theme'));
    });
    observer.observe(document.body, { attributes: true, attributeFilter: ['class'] });
    return () => observer.disconnect();
  }, []);

  const handleSubmit = (inputValue) => {
    if (!connectionStabished) return;

    const command = {
      type: 'message',
      room: serialNumber,
      content: {
        command: 'process',
        parameters: {
          command: inputValue
        }
      }
    };
    socket.send(JSON.stringify(command));
  };

  const handleSubmitAlert = (event) => {
    if (!inputValueAlert || !connectionStabished) return;

    event.preventDefault();
    const command = {
      type: 'alert',
      room: serialNumber,
      msg: inputValueAlert
    };
    socket.send(JSON.stringify(command));

    setInputValueAlert('');
  };

  const base64ToBlob = (base64, mime = 'image/png') => {
    const byteChars = atob(base64);
    const byteNumbers = new Array(byteChars.length);
    for (let i = 0; i < byteChars.length; i++) {
      byteNumbers[i] = byteChars.charCodeAt(i);
    }
    const byteArray = new Uint8Array(byteNumbers);
    return new Blob([byteArray], { type: mime });
  };

  const handleNewFrame = (imgData) => {
    requestRef.current = requestAnimationFrame(() => {
      try {
        const blob = base64ToBlob(imgData, 'image/png');
        if (prevImageUrlRef.current) {
          URL.revokeObjectURL(prevImageUrlRef.current);
        }
        const objectUrl = URL.createObjectURL(blob);
        prevImageUrlRef.current = objectUrl;
        setImageSrc(objectUrl);
      } catch (err) {
        setImageSrc(`data:image/png;base64,${imgData}`);
      }
    });
  };

  const handleImageLoad = (e) => {
    const img = e.target;
    if (!img) return;
    const rect = img.getBoundingClientRect();
    if (rect.width > 0 && rect.height > 0) {
      // placeholder for ratio updates if needed
    }
  };

  const handleConnect = () => {
    let pingInterval
    // Criar uma nova instância WebSocket
    socket = new WebSocket(wsUrl);

    pingInterval = setInterval(() => {
      if (socket.readyState === WebSocket.OPEN) {
        socket.send(JSON.stringify({ type: 'ping' }));
      }
    }, 20000);

    socket.onopen = () => {
      setConnectionStabished(true);
    };

    socket.onmessage = (event) => {
      const data = event.data;
      let json_msg = JSON.parse(data);

      if (json_msg.type === "invalid_user") {
        if (json_msg?.msg) {
          alert(json_msg?.msg);
        } else {
          alert("Sem permissão!");
        }
        handleDisconnect();
      }

      if (json_msg.type === "valid_user") {
        setConnectionStabished(true)
        handleLoadData()
      }

      if (json_msg.type === "desconnect") {
        setConnectionStabished(false)
      }

      if (json_msg.type === "connected") {
        console.log('connected');

        setConnectionStabished(true)
        handleLoadData()
      }

      if (json_msg.pubkey) {

        socket.send(
          JSON.stringify({
            type: 'join',
            room: serialNumber,
            user_id: user?._id,
            name: user?.name,
            email: user?.email,
            client: 'client',
            page: 'supportdry',
            token: getToken(),
            content: {
              name: `${user.email}-API-SUPORTE-DRY`
            },
          }));

      } else {
        if (json_msg?.content?.img) {
          handleNewFrame(json_msg.content.img);
          return;
        }

        if (json_msg?.content?.text) {
          requestAnimationFrame(() => {
            setResponse(json_msg.content.text);
          });
          return;
        }

        if (json_msg?.content?.network_config) {
          // setNetworkConfig(json_msg.content.network_config);
          return;
        }

        if (json_msg?.content?.equip_config) {
          requestAnimationFrame(() => {
            setEquipConfig(json_msg.content.equip_config);
          });
          return;
        }
      }
    };

    socket.onclose = () => {
      clearInterval(pingInterval)
    };
  };

  const handleLoadData = () => {
    socket.send(
      JSON.stringify({
        type: 'message',
        room: serialNumber,
        content: {
          command: 'load_data',
          parameters: {}
        },
      })
    );

    socket.send(
      JSON.stringify({
        type: 'connect_support',
        room: serialNumber,
        hidden: user.master ? user.master : false
      })
    );
  }

  const handleImageClick = (event) => {
    if (!connectionStabished) return;

    const rect = event.target.getBoundingClientRect();
    const x = event.clientX - rect.left;
    const y = event.clientY - rect.top;

    socket.send(
      JSON.stringify({
        type: 'message',
        room: serialNumber,
        content: {
          command: 'click',
          parameters: {
            x: x,
            y: y
          }
        }
      })
    );
  };

  const sendGetScreen = () => {
    if (socket && socket.readyState === WebSocket.OPEN) {
      socket.send(
        JSON.stringify({
          type: 'connect_support',
          room: serialNumber,
          stream_internal_cam: false,
          hidden: user.master ? user.master : false
        })
      );
    }
  };

  useEffect(() => {
    const interval1 = setInterval(() => {
      sendGetScreen();
    }, refreshRate);
    return () => {
      clearInterval(interval1);
    };
  }, [socket]);

  // Função para desconectar o WebSocket
  const handleDisconnect = () => {
    if (socket && socket.readyState === WebSocket.OPEN) {
      socket.send(
        JSON.stringify({
          type: 'desconnect_support',
          room: serialNumber
        })
      );
      socket.close();
      setConnectionStabished(false);
    }
    history.push('/supportdry');
  };

  const handleGetErrors = async () => {
    try {
      const { data } = await Api.get('/troubles/list-equipment', { params: { serial: serialNumber } });
      setErrors(data);
    } catch (error) {
      console.log(error?.message);
    }
  };

  const fetchAjuste = async () => {
    try {
      const { data } = await ApiGServer.get('/equipment/get', {
        headers: { serialnumber: serialNumber }
      });
      const value = data?.ajuste;
      setAjuste(value === null || value === undefined || value === '' ? '' : String(value));
    } catch (error) {
      console.error('Erro ao buscar ajuste do equipamento:', error);
    }
  };

  const handleSaveAjuste = async () => {
    if (!canUpdateAjuste || savingAjuste) return;

    const parsed = Number(ajuste);
    if (!Number.isFinite(parsed)) {
      alert('Informe um número válido para o ajuste.');
      return;
    }
    if (parsed < -5 || parsed > 5) {
      alert('O ajuste deve estar entre -5 e 5.');
      return;
    }

    setSavingAjuste(true);
    try {
      const { data } = await ApiGServer.patch('/equipment/update', {
        serialnumber: serialNumber,
        ajuste: parsed
      });
      const value = data?.ajuste;
      setAjuste(value === null || value === undefined || value === '' ? String(parsed) : String(value));
      alert('Ajuste atualizado com sucesso!');
    } catch (error) {
      console.error('Erro ao atualizar ajuste:', error);
      alert('Falha ao atualizar o ajuste. Tente novamente.');
    } finally {
      setSavingAjuste(false);
    }
  };

  useEffect(() => {
    handleGetErrors(); // Chamada inicial
    fetchAjuste();

    const interval = setInterval(() => {
      handleGetErrors();
    }, 20000); // 20 segundos

    return () => clearInterval(interval); // Limpa o intervalo ao desmontar o componente
  }, []);

  useEffect(() => {
    handleConnect();
    return () => {
      if (socket) socket.close();
      if (requestRef.current) {
        cancelAnimationFrame(requestRef.current);
      }
      if (prevImageUrlRef.current) {
        URL.revokeObjectURL(prevImageUrlRef.current);
      }
    };
  }, []);

  return (
    <Page className="p-3" title="Suporte Dry">
      <Header page={"Suporte Dry"} />

      <Card className={`mb-3 mt-2 ${panelClass}`}>
        <Card.Body className="py-2 px-3">
          <div className="d-flex flex-wrap align-items-center justify-content-between gap-2">
            <div className="d-flex flex-wrap align-items-center gap-2 gap-md-3">
              <span className="conected-session-serial fw-semibold">{serialNumber}</span>
              <Badge
                bg={connectionStabished ? 'success' : 'danger'}
                className="conected-status-badge"
              >
                {connectionStabished ? 'Conectado' : 'Desconectado'}
              </Badge>
            </div>

            <div className="d-flex flex-wrap align-items-center gap-2">
              <Form.Label className="small mb-0 me-1">Ajuste</Form.Label>
              <Form.Control
                type="number"
                size="sm"
                min={-5}
                max={5}
                step={1}
                value={ajuste}
                onChange={(e) => {
                  const next = e.target.value;
                  if (next === '' || next === '-') {
                    setAjuste(next);
                    return;
                  }
                  const parsed = Number(next);
                  if (!Number.isFinite(parsed)) return;
                  setAjuste(String(Math.min(5, Math.max(-5, parsed))));
                }}
                disabled={!canUpdateAjuste || savingAjuste}
                className={isDark ? 'bg-dark text-light border-secondary' : undefined}
                placeholder="0"
                style={{ width: 90 }}
              />
              <Button
                size="sm"
                className="conected-btn-brand"
                onClick={handleSaveAjuste}
                disabled={!canUpdateAjuste || savingAjuste || ajuste === ''}
              >
                {savingAjuste ? 'Salvando...' : 'Salvar'}
              </Button>
              <Button
                size="sm"
                className="conected-btn-danger ms-3"
                onClick={() => handleDisconnect()}
              >
                Desconectar
              </Button>
            </div>
          </div>
        </Card.Body>
      </Card>

      <Card className={`mb-3 p-2 ${panelClass}`}>
        <Row className="g-2">
          <Col>
            <div>
              {!imageSrc ? (
                <div className="conected-stream-placeholder">
                  Aguardando imagem...
                </div>
              ) : (
                <img
                  onClick={handleImageClick}
                  src={imageSrc}
                  alt="Stream remoto do equipamento"
                  style={{
                    width: '800px',
                    height: '480px',
                    objectFit: 'cover',
                    cursor: connectionStabished ? 'pointer' : 'none',
                    opacity: connectionStabished ? 1 : 0.7,
                    filter: connectionStabished ? 'none' : 'grayscale(100%)',
                    borderRadius: '5px',
                    border: '3px solid grey',
                  }}
                />
              )}
            </div>
          </Col>

          <Col>
            <div style={{ height: 480, maxWidth: 800 }}>
              <Tabs defaultActiveKey="1" id="conected-dry-tabs" fill className="conected-tabs-wrap">
                <Tab eventKey="1" title="Terminal">
                  <div style={{ height: 440, overflowY: 'auto' }}>
                    <Terminal
                      onCommandSubmit={handleSubmit}
                      response={response}
                      connectionStabished={connectionStabished}
                      permission={user?.permission?.supportdry?.write}
                    />
                  </div>
                </Tab>

                <Tab eventKey="2" title="Logs">
                  <div style={{ height: 440, overflowY: 'auto' }}>
                    <Logs serialNumber={serialNumber} data={errors} />
                  </div>
                </Tab>

                <Tab eventKey="3" title="Estatística">
                  <div style={{ height: 440, overflowY: 'auto' }}>
                    <Graphic serialNumber={serialNumber} data={errors} />
                  </div>
                </Tab>
              </Tabs>
            </div>
          </Col>
        </Row>
      </Card>

      <Row className="g-3">
        <Col lg={6}>
          <Card className={`h-100 ${panelClass}`}>
            <Card.Header className={panelHeaderClass}>Configuração do equipamento</Card.Header>
            <Card.Body className="p-2">
              <Table
                className={`mb-0 ${isDark ? 'table-dark' : ''}`}
                style={{ fontSize: '0.85rem' }}
                striped
                bordered
                responsive
                size="sm"
              >
                <thead>
                  <tr>
                    <th className="text-center">SERIAL</th>
                    <th className="text-center">FREQUÊNCIA (V)</th>
                    <th className="text-center">ID CALIBRAÇÃO</th>
                    <th className="text-center">WEBCAM</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td className="text-center">{equipConfig.serial}</td>
                    <td className="text-center">{equipConfig.freq_v}</td>
                    <td className="text-center">{equipConfig.calib_id}</td>
                    <td className="text-center">{equipConfig.webcam ? 'Sim' : 'Não'}</td>
                  </tr>
                </tbody>
                <thead>
                  <tr>
                    <th className="text-center">DATA DE ATIVAÇÃO</th>
                    <th className="text-center">DIAS DE ATIVAÇÃO</th>
                    <th className="text-center">SOFTWARE</th>
                    <th className="text-center">SOFTWARE BACKUP</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td className="text-center">{equipConfig.activation_date ? dateformat(equipConfig.activation_date, true) : '--'}</td>
                    <td className="text-center">{equipConfig.activation_days}</td>
                    <td className="text-center">{equipConfig.sw}</td>
                    <td className="text-center">{equipConfig.sws}</td>
                  </tr>
                </tbody>
              </Table>
            </Card.Body>
          </Card>
        </Col>

        <Col lg={6}>
          <Card className={`h-100 ${panelClass}`}>
            <Card.Header className={panelHeaderClass}>Alerta ao equipamento</Card.Header>
            <Card.Body className="p-3 d-flex flex-column gap-2">
              <Form.Control
                onChange={(e) => setInputValueAlert(e.target.value)}
                onKeyDown={(e) => {
                  if (e.key === 'Enter') {
                    handleSubmitAlert(e);
                  }
                }}
                type="text"
                placeholder="Mensagem de alerta..."
                value={inputValueAlert}
                disabled={!canWrite}
              />
              <Button
                onClick={handleSubmitAlert}
                type="button"
                className="conected-btn-success"
                disabled={!canWrite}
              >
                Enviar alerta
              </Button>
            </Card.Body>
          </Card>
        </Col>
      </Row>
    </Page>
  );
};

export default Conected;
